import config from '../config';
import { notifyError, notifySuccess } from '../MyComponents/Toaster';
import axios from 'axios';

const armdv_backend_url = process.env.REACT_APP_ARMDV_BACKEND_API || 'https://staging-api.armdv.com';

const validateInvite = async (
  inviteId: string,
  useMock: boolean = false
): Promise<{
  data: {
    firstName: string;
    lastName: string;
    email: string;
    inviteId: string;
    entityId: string;
    expiresAt: string;
  } | null;
  error: string | null;
}> => {
  if (useMock) {
    await new Promise((res) => setTimeout(res, 2000));
    return {
      data: {
        firstName: "John",
        lastName: "Doe",
        email: "john.doe@example.com",
        inviteId: inviteId,
        entityId: "1",
        expiresAt: "2025-12-31T23:59:59Z",
      },
      error: null,
    };
  }

  try {
    const response = await axios.get(
      `${armdv_backend_url}/invites/validate-invite/${inviteId}`
    );
    return { data: response.data.data, error: null };
  } catch (error: any) {
    return {
      data: null,
      error:
        error?.response?.data?.message || "Invalid or expired invitation.",
    };
  }
};


const activateInvite = async (inviteId: string) => {
  try {
    const response = await axios.patch(
      `${armdv_backend_url}/invites/invitation/${inviteId}/activate`
    );
    return { data: response.data, error: null };
  } catch (error: any) {
    return {
      data: null,
      error: error?.response?.data?.message || "Failed to activate invitation.",
    };
  }
};

export { validateInvite, activateInvite };
